import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1826017e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "font-bold text-2xl" }
const _hoisted_3 = {
  key: 0,
  class: "bg-green-500 text-white rounded-xl p-1 text-xs w-fit"
}
const _hoisted_4 = { class: "block required" }
const _hoisted_5 = { class: "block required" }
const _hoisted_6 = { class: "block required" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex flex-col items-center justify-between gap-x-2 md:flex-row" }
const _hoisted_11 = { class: "flex flex-col items-center gap-x-2 md:flex-row md:flex-grow" }
const _hoisted_12 = { class: "break-all break-words" }
const _hoisted_13 = { class: "text-gray-500 break-all break-words" }
const _hoisted_14 = { class: "text-gray-500 break-all break-words" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-pencil" }, null, -1))
const _hoisted_16 = { class: "block required" }
const _hoisted_17 = { class: "block" }
const _hoisted_18 = { class: "block" }
const _hoisted_19 = { class: "block" }
const _hoisted_20 = { class: "block" }
const _hoisted_21 = { class: "block" }
const _hoisted_22 = {
  key: 0,
  class: "flex items-center gap-x-2"
}
const _hoisted_23 = {
  class: "font-medium cursor-pointer !pb-0",
  for: "notifyClient"
}
const _hoisted_24 = { class: "flex justify-center" }
const _hoisted_25 = { class: "font-medium" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "font-semibold" }
const _hoisted_28 = {
  key: 0,
  class: "italic"
}
const _hoisted_29 = {
  key: 1,
  class: "italic"
}
const _hoisted_30 = { class: "italic" }
const _hoisted_31 = {
  key: 0,
  class: "italic"
}
const _hoisted_32 = {
  key: 2,
  class: "border p-4 rounded-xl shadow flex flex-col gap-2"
}
const _hoisted_33 = { class: "flex flex-col-reverse gap-1 md:flex-row md:justify-between" }
const _hoisted_34 = { class: "font-semibold" }
const _hoisted_35 = { class: "italic" }
const _hoisted_36 = { class: "font-semibold" }
const _hoisted_37 = { class: "pl-4" }
const _hoisted_38 = { class: "font-medium" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "font-medium" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "font-medium" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "font-medium" }
const _hoisted_45 = { key: 1 }

import { channelsList } from "@/assets/utils/translatedEnums";
import PRating from "primevue/rating";
import PAutoComplete from "primevue/autocomplete";
import PMultiSelect from "primevue/multiselect";
import PDialog from "primevue/dialog";
import CClientForm from "@/components/shared/ClientForm.vue";
import { reservationStatusList } from "@/assets/utils/translatedEnums";
import { useRoute, useRouter } from "vue-router";
import CButton from "@/components/Button.vue";
import PCheckbox from "primevue/checkbox";
import PTextArea from "primevue/textarea";
import PCalendar from "primevue/calendar";
import PInputNumber from "primevue/inputnumber";
import PDropDown from "primevue/dropdown";
import {
  computed,
  onMounted,
  ref,
  watch,
  onBeforeMount,
} from "vue";
import { useStore } from "vuex";
import { RESERVATION_CHANNEL, RESERVATION_STATUS } from "@/types";
import { useI18n } from "vue-i18n";
import { cloneDeep } from "lodash";
import { useToast } from "primevue/usetoast";
import { format, parseISO, isValid, isDate } from "date-fns";
import { HHMMFromISO, dateToISO, readableDate } from "@/assets/utils/date";
import { useVuelidate } from "@vuelidate/core";
import FormErrors from "@/components/FormErrors.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationForm',
  props: {
  isLoading: {
    type: Boolean,
    default: false,
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
  reservationData: {
    type: Object,
    default: null,
  },
},
  emits: ["save", "cancel"],
  setup(__props, { emit }) {

const props = __props;

const toast = useToast();
const { t } = useI18n();
const store = useStore();
const route = useRoute();
const router = useRouter();




let rules = ref();
const changeRules = () => {
  rules.value = props.isUpdate
    ? store.getters[
        `reservation/rulesToUpdateA${
          notifyClient.value ? "Notifiable" : ""
        }Reservation`
      ]
    : store.getters[
        `reservation/rulesToCreateA${
          notifyClient.value ? "Notifiable" : ""
        }Reservation`
      ];
  v$ = useVuelidate(rules.value, reservation, { $lazy: true });
};

const selectAt = (date: Date) => {
  reservation.value.at = dateToISO({ date });
};
const isShowNotifyClient = ref(false);
const selectStatus = ({ value }: any) => {
  if (
    ![
      RESERVATION_STATUS.CONFIRMED,
      RESERVATION_STATUS.WAITING_CONFIRMATION,
    ].includes(value)
  ) {
    notifyClient.value = false;
    isShowNotifyClient.value = false;
  } else {
    isShowNotifyClient.value = true;
  }
};
const isShowAddClientForm = ref(false);
const spaces = computed(() => {
  return store.getters["pos/spaces"];
});
const TablesOfSelectedSpace = computed(() => {
  return (spaces.value ?? []).find(
    (space: any) => space.id === reservation.value.spaceId
  )?.tables;
});
const searchClientTerm = ref("");
const isChangeClient = ref(true);
const toggleChangeClient = (show = true) => {
  isChangeClient.value = show;
};
const formatedAt = computed(() => {
  return isDate(reservation.value.at)
    ? reservation.value.at
    : parseISO(reservation.value.at);
});

const toggleShowAddClientForm = (show = true) => {
  isShowAddClientForm.value = show;
};
const notifyClient = ref(false);
const initReservation = () => {
  if (props.isUpdate) {
    const result = cloneDeep(props.reservationData);
    return result;
  } else {
    const q = route.query;
    return cloneDeep({
      status: q.status ?? RESERVATION_STATUS.WAITING_CONFIRMATION,
      spaceId: q.spaceId ?? null,
      tableIds: q.tableId ?? null,
      comment: "",
      client: {},
      attendeesCount: 1,
      at: isValid(new Date(q.at as string))
        ? (q.at as string)
        : dateToISO({ date: new Date() }),
      teamMemberId: q.teamMemberId ?? null,
    });
  }
};
const reservation = ref<any>(initReservation());
let v$;

const isCreationOfClienLoading = ref(false);
// const getClientById = async (id: string) => {
//   const foundClient = await store.dispatch("client/GET_CLIENT_BY_ID", {
//     clientId: id,
//   });
//   foundClients.value = [foundClient];
// };
const addClient = async (client: any) => {
  v$.value.client.$model = client;
  toggleShowAddClientForm(false);
  toggleChangeClient(false);
};
const currentPos = computed(() => {
  return store.getters["pos/currentPos"];
});

const canEdit = computed(() => {
  return ["admin", "agent"].includes(currentPos.value.role);
});
onBeforeMount(async () => {
  // await retrievePos();
  if (props.isUpdate) {
    // await getClientById(reservation.value.clientId);
    toggleChangeClient(false);
  }
  selectStatus({ value: reservation.value.status });
  changeRules();
});
const foundClients = ref<any>([]);
const searchClients = async (value: string) => {
  foundClients.value = await store.dispatch("client/FIND_CLIENTS", {
    word: value,
  });
};
const selectClient = (client: any) => {
  reservation.value.client = client;
  searchClientTerm.value = "";
  toggleChangeClient(false);
};
const save = async () => {
  if (await v$.value.$validate()) {
    emit("save", {
      reservation: cloneDeep(reservation.value),
      notifyClient: notifyClient.value,
    });
  }
};
watch(
  reservation,
  (change) => {
    const query = { ...route.query };
    if (change.status) {
      query.status = change.status;
    }
    if (change.spaceId) {
      query.spaceId = change.spaceId;
    }
    if (change.tableIds) {
      query.tableIds = change.tableIds;
    }
    if (change.at) {
      query.at = change.at;
    }
    if (change.teamMemberId) {
      query.teamMemberId = change.teamMemberId;
    }
    router.replace({
      name: props.isUpdate ? "ReservationEdit" : "AddReservation",
      query,
    });
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-y-4 p-8",
    onSubmit: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        (__props.isUpdate)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.$t("UpdateReservation")), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.$t("NewReservation")), 1)
            ], 64))
      ]),
      (__props.isUpdate && reservation.value?.isOnline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("online")), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("status")), 1),
      _createVNode(_unref(PDropDown), {
        class: "w-full",
        placeholder: _ctx.$t('status'),
        options: _unref(reservationStatusList)(_ctx.$t),
        "option-label": "name",
        "option-value": "id",
        "data-key": "id",
        modelValue: _unref(v$).status.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).status.$model) = $event)),
        onChange: selectStatus
      }, null, 8, ["placeholder", "options", "modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).status.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("reservationDate")), 1),
      _createVNode(_unref(PCalendar), {
        disabled: !_unref(canEdit),
        "show-icon": "",
        class: "w-full",
        "model-value": _unref(formatedAt),
        showTime: "",
        hourFormat: "24",
        stepMinute: 15,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (selectAt($event)))
      }, null, 8, ["disabled", "model-value"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).at.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'disabled-content': !_unref(canEdit) })
    }, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("client")), 1),
      (isChangeClient.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(PAutoComplete), {
              class: "w-full",
              dropdown: "",
              dropdownIcon: "pi pi-search",
              suggestions: foundClients.value,
              modelValue: searchClientTerm.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchClientTerm).value = $event)),
              onComplete: _cache[3] || (_cache[3] = ($event: any) => (searchClients($event.query))),
              onItemSelect: _cache[4] || (_cache[4] = ($event: any) => (selectClient($event.value)))
            }, {
              option: _withCtx(({ option }) => [
                _createElementVNode("div", null, _toDisplayString(option.firstName) + " " + _toDisplayString(option.lastName) + " / " + _toDisplayString(option.phoneNumber) + "/" + _toDisplayString(option.email), 1)
              ]),
              _: 1
            }, 8, ["suggestions", "modelValue"]),
            _createElementVNode("div", {
              class: "text-right cursor-pointer pt-4 hover:underline",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleShowAddClientForm(true)))
            }, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("addNewClient")), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (reservation.value.client?.gender)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t(reservation.value.client?.gender)), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(reservation.value.client?.firstName) + " " + _toDisplayString(reservation.value.client?.lastName), 1)
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(reservation.value.client?.phoneNumber), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(reservation.value.client?.email), 1)
              ]),
              _createElementVNode("div", {
                class: "text-right cursor-pointer hover:underline",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleChangeClient(true)))
              }, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("changeClient")), 1)
              ])
            ])
          ]))
    ], 2),
    _createVNode(FormErrors, {
      errors: _unref(v$).client?.$errors?.length ? [_unref(v$).client.$errors[0]] : []
    }, null, 8, ["errors"]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("attendeesCount")), 1),
      _createVNode(_unref(PInputNumber), {
        disabled: !_unref(canEdit),
        class: "w-full",
        mode: "decimal",
        showButtons: "",
        step: 1,
        min: 1,
        modelValue: _unref(v$).attendeesCount.$model,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).attendeesCount.$model) = $event)),
        buttonLayout: "horizontal",
        incrementButtonIcon: "pi pi-plus",
        decrementButtonIcon: "pi pi-minus"
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).attendeesCount.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("reservationChanel")), 1),
      _createVNode(_unref(PDropDown), {
        filter: "",
        class: "w-full",
        options: _unref(channelsList)(_ctx.$t),
        "option-label": "name",
        "option-value": "id",
        "data-key": "id",
        modelValue: _unref(v$).channel.$model,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).channel.$model) = $event)),
        showClear: ""
      }, null, 8, ["options", "modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).channel.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("space")), 1),
      _createVNode(_unref(PDropDown), {
        disabled: !_unref(canEdit),
        filter: "",
        class: "w-full",
        options: _unref(spaces),
        "option-label": "name",
        "option-value": "id",
        "data-key": "id",
        modelValue: _unref(v$).spaceId.$model,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).spaceId.$model) = $event)),
        showClear: ""
      }, null, 8, ["disabled", "options", "modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).spaceId.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'disabled-content': !reservation.value.spaceId })
    }, [
      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("table")), 1),
      _createVNode(_unref(PMultiSelect), {
        disabled: !_unref(canEdit),
        filter: "",
        class: "w-full",
        options: _unref(TablesOfSelectedSpace),
        mul: "",
        "option-label": "name",
        "option-value": "id",
        "data-key": "id",
        modelValue: _unref(v$).tableIds.$model,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).tableIds.$model) = $event)),
        showClear: ""
      }, null, 8, ["disabled", "options", "modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).tableIds.$errors
      }, null, 8, ["errors"])
    ], 2),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("comment")), 1),
      _createVNode(_unref(PTextArea), {
        disabled: !_unref(canEdit),
        modelValue: _unref(v$).comment.$model,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).comment.$model) = $event)),
        class: "w-full p-2 min-h-[4rem]"
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).comment.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("amount")), 1),
      _createVNode(_unref(PInputNumber), {
        disabled: !_unref(canEdit),
        modelValue: _unref(v$).amount.$model,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).amount.$model) = $event)),
        class: "w-full p-2 min-h-[4rem]",
        minFractionDigits: 2,
        maxFractionDigits: 5
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).amount.$errors
      }, null, 8, ["errors"])
    ]),
    (isShowNotifyClient.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(_unref(PCheckbox), {
            modelValue: notifyClient.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((notifyClient).value = $event)),
            binary: true,
            inputId: "notifyClient",
            onChange: changeRules
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("notifyClient")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(CButton, {
        class: "w-fit",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_25, [
            (__props.isUpdate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("updateReservationDetail")), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("takeReservation")), 1)
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(PDialog), {
      visible: isShowAddClientForm.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((isShowAddClientForm).value = $event)),
      modal: "",
      header: _ctx.$t('addNewClient')
    }, {
      default: _withCtx(() => [
        (isShowAddClientForm.value)
          ? (_openBlock(), _createBlock(CClientForm, {
              key: 0,
              "is-online": reservation.value.isOnline,
              "is-loading": isCreationOfClienLoading.value,
              onSave: addClient,
              onCancel: _cache[14] || (_cache[14] = ($event: any) => (toggleShowAddClientForm(false)))
            }, null, 8, ["is-online", "is-loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    (__props.isUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.$t("history")), 1),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("createdBy")) + " ", 1),
            (reservation.value.createdBy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(`${reservation.value.createdBy?.firstName ?? "--"} ${
            reservation.value.createdBy?.lastName ?? "--"
          }`), 1))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("on")) + " ", 1),
            (reservation.value.createdAt)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(reservation.value.createdAt ? _unref(HHMMFromISO)(reservation.value.createdAt) : "--"), 1))
              : _createCommentVNode("", true)
          ]),
          (reservation.value.updateHistory?.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(reservation.value.updateHistory, (updateHistory, updateHistoryIndex) => {
                return (_openBlock(), _createElementBlock("div", { key: updateHistoryIndex }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("updatedBy")) + " ", 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(`${updateHistory.firstName ?? ""} ${updateHistory.lastName ?? ""}`), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("on")) + " ", 1),
                  (updateHistory.at)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(HHMMFromISO)(updateHistory.at)), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (reservation.value.rating)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("h2", _hoisted_34, _toDisplayString(_ctx.$t("clientRating")), 1),
              _createElementVNode("span", _hoisted_35, "(" + _toDisplayString(_ctx.$t("on")) + " " + _toDisplayString(_unref(HHMMFromISO)(reservation.value.rating?.at)) + ")", 1)
            ]),
            (reservation.value.rating.rating)
              ? (_openBlock(), _createBlock(_unref(PRating), {
                  key: 0,
                  modelValue: reservation.value.rating.rating,
                  cancel: false,
                  readonly: ""
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_36, _toDisplayString(_ctx.$t("comment")), 1),
            _createElementVNode("p", null, _toDisplayString(reservation.value.rating?.comment), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.$t("atmosphere")), 1),
              (reservation.value.rating?.atmosphere?.rating)
                ? (_openBlock(), _createBlock(_unref(PRating), {
                    key: 0,
                    modelValue: reservation.value.rating.atmosphere?.rating,
                    cancel: false,
                    readonly: ""
                  }, null, 8, ["modelValue"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(reservation.value.rating?.atmosphere?.comment ??
              `(${_ctx.$t("ratingWasntFilled")})`), 1)),
              _createElementVNode("p", null, _toDisplayString(reservation.value.rating?.atmosphere?.comment ??
              `(${_ctx.$t("commentWasntFilled")})`), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_40, _toDisplayString(_ctx.$t("service")), 1),
              (reservation.value.rating?.service.rating)
                ? (_openBlock(), _createBlock(_unref(PRating), {
                    key: 0,
                    modelValue: reservation.value.rating?.service.rating,
                    cancel: false,
                    readonly: ""
                  }, null, 8, ["modelValue"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(reservation.value.rating?.service?.comment ??
              `(${_ctx.$t("ratingWasntFilled")})`), 1)),
              _createElementVNode("p", null, _toDisplayString(reservation.value.rating?.service?.comment ??
              `(${_ctx.$t("commentWasntFilled")})`), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_42, _toDisplayString(_ctx.$t("food")), 1),
              (reservation.value.rating?.food.rating)
                ? (_openBlock(), _createBlock(_unref(PRating), {
                    key: 0,
                    modelValue: reservation.value.rating?.food.rating,
                    cancel: false,
                    readonly: ""
                  }, null, 8, ["modelValue"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(reservation.value.rating?.food?.comment ??
              `(${_ctx.$t("ratingWasntFilled")})`), 1)),
              _createElementVNode("p", null, _toDisplayString(reservation.value.rating?.food?.comment ??
              `(${_ctx.$t("commentWasntFilled")})`), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_44, _toDisplayString(_ctx.$t("qualityPriceRatio")), 1),
              (reservation.value.rating?.qualityPriceRatio.rating)
                ? (_openBlock(), _createBlock(_unref(PRating), {
                    key: 0,
                    modelValue: reservation.value.rating?.qualityPriceRatio.rating,
                    cancel: false,
                    readonly: ""
                  }, null, 8, ["modelValue"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(reservation.value.rating?.v?.comment ?? `(${_ctx.$t("ratingWasntFilled")})`), 1)),
              _createElementVNode("p", null, _toDisplayString(reservation.value.rating?.qualityPriceRatio?.comment ??
              `(${_ctx.$t("commentWasntFilled")})`), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})